module.exports = __webpack_public_path__ + "img/xuanchuan.e5349388.png";